export const NOTIFICATION_CHANNELS = ['SMS_AND_EMAIL', 'SMS', 'EMAIL'] as const;
export type NotificationChannel = typeof NOTIFICATION_CHANNELS[number];

export type NotificationChannelFieldFormBeanPart = { preInterviewNotificationChannel: NotificationChannel };
